export const NUM_IMPROVISERS_CHANGED = 'NUM_IMPROVISERS_CHANGED'

export const numImprovisersChanged = ({ numImprovisers }) => {
    return { type: NUM_IMPROVISERS_CHANGED, numImprovisers }
}


// WEBPACK FOOTER //
// ./src/reducers/numImprovisers/actions.js